import Vue from "vue";
import Router from "vue-router";

import home from "./modules/home/router";
import user from "./modules/user/router";
import jenisKelas from "./modules/jenisKelas/router";
import kelas from "./modules/kelas/router";
import instansi from "./modules/instansi/router";
import akses from "./modules/akses/router";
import diklat from "./modules/diklat/router";
import angkatan from "./modules/angkatan/router";
import informasi from "./modules/informasi/router";

import store from "./store";
import { isCan } from "./tools";
import { BASE_API } from "@/const";

Vue.use(Router);

const other = [
  {
    path: "/",
    name: "root",
    redirect: {
      name: "instansi.pilih"
    },
    meta: {
      analyticsIgnore: true
    }
  },
  {
    path: "*",
    name: "404",
    component: () => import("./modules/404/pages/404")
  },
  {
    path: "/gbb/:seri/:angkatan/:state",
    name: "no-content",
    module: "Konten Tidak Tersedia",
    meta: {
      auth: false,
      module: "Konten Tidak Tersedia"
    },
    component: () => import("./modules/404/pages/NoKonten.vue")
  }
];

let routers = [...home, ...jenisKelas, ...angkatan, ...kelas, ...instansi, ...other, ...user, ...akses, ...diklat, ...informasi];

const router = new Router({
  // mode: 'history',
  // base: process.env.BASE_URL,
  routes: routers
});

router.beforeResolve((to, from, next) => {
  if (to.name) {
    store.commit("main/pStart");
  }
  next();
});

router.beforeEach((to, from, next) => {
  //cek apakah perlu login
  store.commit("main/cleanFlag");
  if (to.meta && to.meta.auth) {
    //load permission
    store
      .dispatch("user/fetch")

      .then(() => {
        // jika auth ok, maka cek routing var
        // cek apakah perlu load instansi
        if (!store.getters["main/403"] && to.params.instansi_id) {
          return store.dispatch("instansi/switchInstansi", to.params.instansi_id);
        }
      })
      .then(() => {
        // cek apakah dapat mengakses route
        return store.commit("main/403", !isCan(to.meta.auth));
      })
      .then(() => {
        if (to.params.instansi_id) {
          return store.dispatch("user/getRole", to.params.instansi_id);
        }
      })
      .then(() => {
        var roles = store.getters["user/roles"];
        var currentRole = store.getters["user/currentRole"];
        if (to.params.instansi_id && roles.length > 0 && !currentRole) {
          return store.dispatch("user/getPermissionByRole", { instansi_id: to.params.instansi_id, peran_id: roles[0].id });
        }
      })
      .then(() => {
        next();
      })
      .catch(() => {
        var url_redirect = BASE_API + "?path=" + to.fullPath;
        window.location.href = url_redirect;
      });
  } else {
    next();
  }
});

router.afterEach(() => {
  store.commit("main/pEnd");
  window.scrollTo(0, 0);
});

export default router;
